module.exports = __webpack_public_path__ + "static/img/userDefaultImg.e536758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userDefaultImg.png
// module id = 9LnK
// module chunks = 1